import { of as observableOf, Observable } from 'rxjs';

import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { Users } from 'county-api';
import { UsersService } from '../users.service';
import moment from 'moment';

/**
 * Maps the data from the users service for the user of the given id.
 */
@Injectable()
export class UserResolve  {
    constructor(private usersService: UsersService, private router: Router) {}

    /**
     * Uses the current route and maps the passed in id to the url to get the user data.
     * @param route The current route used to pass route.
     */
    resolve(route: ActivatedRouteSnapshot) {
        return this.usersService.getById(route.paramMap.get('id')).pipe(
            map(data => {
                const user = data.result.user;

                return user;
            }),
            catchError(error => {
                // Delay the navigation in order to maintain the url states.
                setTimeout(() =>
                    this.router.navigate(['/users'], {
                        skipLocationChange: true,
                    }),
                );
                return observableOf(false);
            }),
        );
    }
}
